import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const KYC_DOCS = [["aadhaar_front", "Aadhaar front"], ["aadhaar_back", "Aadhaar back"], ["pan", "PAN card"], ["photo", "Agent photo"]];

export const uploadKycDoc = (url, docType, file) => {
  const fd = new FormData();
  fd.append("doc_type", docType);
  fd.append("file", file);
  return api.post(url, fd);
};

function DocImage({ userId, doc, version }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    let url;
    setSrc(null); setErr("");
    api.get(`/kyc-docs/${userId}/${doc}`, { responseType: "blob" })
      .then(({ data }) => { url = URL.createObjectURL(data); setSrc(url); })
      .catch(() => setErr("Not uploaded"));
    return () => url && URL.revokeObjectURL(url);
  }, [userId, doc, version]);
  if (err) return <div className="grid h-36 place-items-center rounded bg-red-50 text-xs font-semibold text-red-600">{err}</div>;
  if (!src) return <div className="grid h-36 place-items-center rounded bg-slate-50 text-xs text-slate-400">Loading…</div>;
  return <a href={src} target="_blank" rel="noreferrer"><img src={src} alt={doc} onError={() => setErr("Image unavailable")} className="h-36 w-full rounded border border-slate-200 bg-slate-50 object-contain" data-testid={`kyc-img-${doc}`} /></a>;
}

export function KycDocsPanel({ user, uploadUrl, onChange }) {
  const [version, setVersion] = useState(0);
  const docs = user.kyc_docs || {};
  const upload = async (doc, file) => {
    if (!file) return;
    try { await uploadKycDoc(uploadUrl, doc, file); toast.success("Document uploaded"); setVersion(version + 1); onChange && onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="kyc-docs-panel">
      <div className="mb-3 grid grid-cols-2 gap-2 text-sm">
        <div>Aadhaar: <b className="font-mono" data-testid="kyc-aadhaar">{user.aadhaar || "-"}</b></div>
        <div>PAN: <b className="font-mono" data-testid="kyc-pan">{user.pan || "-"}</b></div>
        {user.bank_account && <div>Bank A/c: <b className="font-mono" data-testid="kyc-bank">{user.bank_account}</b></div>}
        {user.ifsc && <div>IFSC: <b className="font-mono" data-testid="kyc-ifsc">{user.ifsc}</b></div>}
        {user.address && <div className="col-span-2">Address: <b data-testid="kyc-address">{user.address}</b></div>}
        {user.created_by && <div className="col-span-2 text-xs text-slate-500">Created by {user.created_by}{user.approved_by ? ` · approved by ${user.approved_by}` : ""}</div>}
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {KYC_DOCS.map(([k, l]) => (
          <div key={k}>
            <div className="np-label mb-1">{l}</div>
            {docs[k] || version ? <DocImage userId={user.id} doc={k} version={version} /> : <div className="grid h-36 place-items-center rounded bg-red-50 text-xs font-semibold text-red-600">Not uploaded</div>}
            {uploadUrl && <input type="file" accept="image/png,image/jpeg,image/webp" className="mt-1 w-full text-xs" onChange={(e) => upload(k, e.target.files[0])} data-testid={`kyc-upload-${k}`} />}
          </div>
        ))}
      </div>
    </div>
  );
}
